module.exports = __webpack_public_path__ + "static/img/6.38a6b12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/eng/6.png
// module id = gNu/
// module chunks = 0